<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/activitynoticemanage/select"
      :model="formModel"
      @openAddDialog="changeNote"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      addShowPower="/activitynoticemanage/add"
    >
      <el-form-item label="标题名称">
        <el-input
          v-model="formModel.subject"
          maxlength="20"
          placeholder="请输入标题名称"
        ></el-input>
      </el-form-item>
      <!--<el-form-item label="通知内容">-->
      <!--<el-input v-model="formModel.content" maxlength="50" placeholder="请输入通知内容"></el-input>-->
      <!--</el-form-item>-->
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        type="index"
        min-width="80"
        label="序号"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="subject"
        show-overflow-tooltip
        min-width="160"
        label="标题名称"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="status"
        show-overflow-tooltip
        min-width="100"
        label="状态"
      >
        <template slot-scope="scope">
          <p>{{ scope.row.status == 1 ? "启用" : "禁用" }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="详情"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="updateUserName"
        label="修改人"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column label="操作" min-width="220">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDetail(scope.row.id)"
            >详情</el-button
          >
          <el-button type="text" @click="changeNote(scope.row.id)"
            >修改</el-button
          >
          <el-button
            type="text"
            @click="handleChange(scope.row.id, scope.row.status)"
          >
            {{ scope.row.status == 1 ? "禁用" : "启用" }}
          </el-button>
          <el-button
            type="text"
            @click="handleChange(scope.row.id, 2)"
            class="button-color"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="formDialogTitle"
      :model="dialogModel"
      labelWidth="110px"
      :dialogService="dialogService"
      :submitData="dialogData"
      :rules="dialogRules"
      class="over addNotice"
      @success="dialogSuccess"
      @close="dialogClose"
      @opend="dialogOpen"
    >
      <el-form-item label="标题名称" prop="subject">
        <el-input
          v-model="dialogModel.subject"
          :disabled="disabled"
          maxlength="20"
          placeholder="请输入标题名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="消息内容" prop="content">
        <el-input
          type="textarea"
          maxlength="500"
          show-word-limit
          resize="none"
          rows="5"
          v-model="dialogModel.content"
          :disabled="disabled"
          placeholder="请输入消息标题"
        ></el-input>
      </el-form-item>

      <!--<el-form-item label="是否启用" prop="status">-->
      <!--<el-switch-->
      <!--class="noBut"-->
      <!--v-model="dialogModel.status"-->
      <!--:disabled="disabled"-->
      <!--active-value="1"-->
      <!--inactive-value="0">-->
      <!--</el-switch>-->
      <!--</el-form-item>-->
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import ElFormItem from "element-ui/packages/form/src/form-item";
import FormDialog from "../../dialog/FormDialog";

import APPService from "service/APPService";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "activitynoticemanage",
  data() {
    return {
      formModel: {
        subject: "",
        content: "",
      },
      tableData: [],
      submitService: APPService.tatActivityMsg,
      page: {},
      formDialogTitle: "",
      dialogModel: {
        subject: "",
        content: "",
        status: "1",
      },
      dialogRules: {
        subject: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.trim() == "") {
                callback(new Error("请输入标题名称"));
              } else {
                callback();
              }
            },
          },
        ],
        content: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.trim() == "") {
                callback(new Error("请输入消息内容"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      isPage: false,
      disabled: false,
      noticeId: "",
      dialogService: null,
    };
  },
  mixins: [loadMixin, dialogMixin],
  components: {
    ElFormItem,
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  computed: {
    dialogData() {
      const params = {
        userId: this.userId,
        subject: this.dialogModel.subject.trim(),
        content: this.dialogModel.content.trim(),
        status: this.dialogModel.status,
      };
      if (this.noticeId) {
        params.id = this.noticeId;
      }
      params[this.noticeId ? "updateUser" : "createUser"] = this.userId;
      return params;
    },
    submitData() {
      this.params = {
        subject: this.formModel.subject.trim(),
        content: this.formModel.content.trim(),
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      return this.params;
    },
    ...mapGetters(["userId"]),
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  methods: {
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    changeNote(id) {
      this.noticeId = id;
      this.dialogService = this.noticeId
        ? APPService.tatActivityMsgUpd
        : APPService.tatActivityMsgAdd;
      this.formDialogTitle = this.noticeId ? "修改公告" : "新建公告";
      this.$refs.formDialog.open();
    },
    dialogSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.showSuccess(result.optMsg);
        this.getList();
        this.$refs.formDialog.closeDialog();
      });
    },
    dialogClose() {
      this.disabled = false;
      this.dialogModel = {
        subject: "",
        content: "",
        status: "1",
      };
    },
    dialogOpen() {
      if (this.noticeId) {
        this.getDetail();
      }
    },
    handleDetail(id) {
      this.disabled = true;
      this.changeNote(id);
    },
    getDetail() {
      this.tableData.forEach((item) => {
        if (item.id == this.noticeId) {
          item.status = item.status.toString();
          this.dialogModel = JSON.parse(JSON.stringify(item));
        }
      });
    },
    doDelete(id) {
      const deleteParams = {
        id: id,
      };

      this.doLoad(APPService.tatActivityMsgDel, deleteParams, (res) => {
        this.doCheck(res, (res) => {
          const result = res.contents;
          this.showSuccess(result.optMsg);
          this.getList();
        });
      });
    },
    doStatus(id, type) {
      const deleteParams = {
        id: id,
        status: type == 1 ? 0 : 1,
        userId: this.userId,
      };

      this.doLoad(APPService.tatActivityMsgUdp, deleteParams, (res) => {
        this.doCheck(res, (res) => {
          const result = res.contents;
          this.showSuccess(result.optMsg);
          this.getList();
        });
      });
    },
    handleChange(id, type) {
      const showMsg =
        type == 2
          ? "确定删除该通知？"
          : type == 1
          ? "确定禁用该通知？"
          : "确定启用该通知？";
      this.showConfirm(showMsg)
        .then(() => {
          type == 2 ? this.doDelete(id) : this.doStatus(id, type);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/ActivityNoticeManage.vue